import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Help_Seo from '../../SEO/Help_Seo';
import FsLightbox from 'fslightbox-react';
import AOS from 'aos';

function Help() {
    const [isLoading, setIsLoading] = useState(true);
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        source: '',
    });

    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);

    const openVideoPopup = (videoUrl) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            source: videoUrl,
        });
    };
    useEffect(() => {
        AOS.init({
            duration: 3000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);

    return (
        <>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Help_Seo />
                    <Header />
                    {/* Internal CSS */}
                    <style>
                        {`
                            .circle {
                                transform: translate(130%, -50%);
                                transition: 0.5s;
                            }
                            @media only screen and (max-width: 767px) {
                                .circle {
                                    transform: translate(195%, -50%);
                                }
                                .video-play {
                                    width: 55px;
                                    height: 55px;
                                }
                            }
                        `}
                    </style>
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Help</h1>
                                <ul>
                                    <li><NavLink to="/">Home</NavLink></li>
                                    <li>Help</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}
                    {/* Help section start */}
                    <div className="help-tabs2 ptb-100">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="content-title style1 mb-4">
                                        <span>For Documents</span>
                                    </div>
                                    <div className="wh-item-wrap mb-4" data-aos-delay={200}>
                                        <div className="wh-item" style={{ alignItems: 'center' }}>
                                            <div className="wh-icon">
                                                <img src="assets/images/photo/kyc.png" alt="KYC" />
                                            </div>
                                            <div className="wh-text">
                                                <h5><NavLink to="/onboarding">KYC Upload</NavLink></h5>
                                            </div>
                                            <button
                                                className="video-play circle"
                                                onClick={() => openVideoPopup("https://www.youtube.com/watch?v=qceO0YPfcVo")}
                                            >
                                                <i className="fa-solid fa-play"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="content-title style1 mb-4">
                                        <span>For Safety</span>
                                    </div>
                                    <div className="wh-item-wrap mb-4" data-aos-delay={300}>
                                        <div className="wh-item" style={{ alignItems: 'center' }}>
                                            <div className="wh-icon">
                                                <img src="assets/images/photo/data-safety.png" alt="Data Safety" />
                                            </div>
                                            <div className="wh-text">
                                                <h5><NavLink to="/data-safety">Data Safety</NavLink></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="content-title style1 mb-4">
                                        <span>For FAQ's</span>
                                    </div>
                                    <div className="wh-item-wrap mb-4" data-aos-delay={400}>
                                        <div className="wh-item" style={{ alignItems: 'center' }}>
                                            <div className="wh-icon">
                                                <img src="assets/images/photo/onbordingfaq.png" alt="Onboarding FAQ" />
                                            </div>
                                            <div className="wh-text">
                                                <h5><NavLink to="/onboarding-faq">Onboarding FAQs</NavLink></h5>
                                            </div>
                                        </div>
                                        <div className="wh-item" style={{ alignItems: 'center' }}>
                                            <div className="wh-icon">
                                                <img src="assets/images/photo/faq.png" alt="General FAQ" />
                                            </div>
                                            <div className="wh-text">
                                                <h5><NavLink to="/general-faq">General FAQs</NavLink></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Help section end */}
                    {/* Footer Section Here */}
                    <Footer />
                    {/* FsLightbox Component */}
                    <FsLightbox
                        toggler={lightboxController.toggler}
                        sources={[lightboxController.source]}
                    />
                </>
            )}
        </>
    );
}

export default Help;
